(() => {
  if (customElements.get('chef-lifestyle-slideshow')) return;

  class ChefLifestyleSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-lifestyle-slide]')];
      if (this.slides.length < 2) return;
      this.lifecycle?.abort();
      this.lifecycle = new AbortController();
      const on = (target, type, handler) => target.addEventListener(type, handler, { signal: this.lifecycle.signal });
      this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.keyboardPaused = false;
      this.visible = false;
      this.interval = Math.max(3000, Math.min(8000, Number(this.dataset.interval) || 4000));
      const card = this.closest('.cc-editorial-card');

      on(card, 'focusin', event => {
        // Keep the image still while a keyboard user reads the card's link.
        if (!card.contains(event.relatedTarget) && event.target.matches(':focus-visible')) {
          this.keyboardPaused = true;
          this.sync();
        }
      });
      on(card, 'focusout', event => {
        if (!card.contains(event.relatedTarget)) {
          this.keyboardPaused = false;
          this.sync();
        }
      });
      on(document, 'visibilitychange', () => this.sync());
      on(this.motion, 'change', () => this.sync());
      this.visibility = new IntersectionObserver(entries => {
        this.visible = entries.some(entry => entry.isIntersecting);
        this.sync();
      });
      this.visibility.observe(card);
      this.sync();
    }

    advance() {
      for (let step = 1; step < this.slides.length; step += 1) {
        const next = (this.index + step) % this.slides.length;
        const image = this.slides[next].querySelector('img');
        if (!image.complete || !image.naturalWidth) continue;
        this.index = next;
        this.slides.forEach((slide, index) => {
          const active = index === next;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        break;
      }
    }

    sync() {
      clearTimeout(this.timer);
      const paused = this.dataset.autoplay !== 'true' || this.motion.matches || this.keyboardPaused;
      this.dataset.paused = String(paused);
      if (!this.isConnected || paused || !this.visible || document.hidden) return;
      this.timer = setTimeout(() => {
        this.advance();
        this.sync();
      }, this.interval);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.visibility?.disconnect();
      this.lifecycle?.abort();
    }
  }

  customElements.define('chef-lifestyle-slideshow', ChefLifestyleSlideshow);
})();
